import { UrlApi } from "../../services/apirest";
import { getData } from "../../services/library";
import { putData } from "../../services/library";
import { useState } from "react";

//MODIFICACION DE FACTIBILIDAD
export function getArtefactos(factuuid, setData){
    return getData("/fact_artefactos/" + factuuid, setData);
}

export function getFactConfig(props, setFactConfig, setCalculos) {
    fetch(UrlApi + "/factconfig")
      .then((data) => data.json())
      .then((data) => {
        setFactConfig(data[0]);
        setCalculos((calculos) => ({
          ...calculos,
          costos_operativos_xtn_pesos:
            props.fact.precio_dolar * data[0].costos_operativos,
        }));
        // setCalculos(props.fact.precio_dolar * data[0].costos_operativos)
      });
  };

export function getDataSucursal(dataDir, setDataSucursal, mapParams, setMapParams) {
    fetch(UrlApi + "/sucursales/" + dataDir.id_sucursal)
        .then((data) => data.json())
        .then((data) => {
            setDataSucursal(data[0]);
            !dataDir.latitud &&
                !dataDir.longitud &&
                setMapParams({
                    ...mapParams,
                    center: {
                        lat: data[0].latitud * 1,
                        lng: data[0].longitud * 1,
                    },
                });
        });
};

export function getDataCliente(uuidCli, setDataCliente, setShowDropdownConvenios) {
    fetch(`${UrlApi}/clientes/uuid/${uuidCli}`)
        .then((data) => data.json())
        .then((data) => {
            setDataCliente(data[0]);
            setShowDropdownConvenios(!!data[0].id_convenio);
        });
}

export function getMailSolicitante(id, setMailSolicitante) {
    fetch(UrlApi + "/representantes/getid/" + id)
      .then((data) => data.json())
      .then((data) => setMailSolicitante(data[0].mail || ""));
  };


//FIN MODIFICACION FACTIBILIDAD